var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.accessible && _vm.loaded)?_c('div',{staticClass:"body"},[_c('div',{staticClass:"body"},[_c('router-view')],1)]):_c('Container',{attrs:{"loaded":_vm.loaded,"accessible":_vm.accessible,"error":'403',"viewn":'project_settings_menu'}})
}
var staticRenderFns = []

export { render, staticRenderFns }